import { render, staticRenderFns } from "./Adesioni.vue?vue&type=template&id=273df6ea&"
import script from "./Adesioni.vue?vue&type=script&lang=js&"
export * from "./Adesioni.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports